import { render, staticRenderFns } from "./AppDropdownMenu.vue?vue&type=template&id=371644ac&scoped=true"
import script from "./AppDropdownMenu.vue?vue&type=script&lang=js"
export * from "./AppDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./AppDropdownMenu.vue?vue&type=style&index=0&id=371644ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371644ac",
  null
  
)

export default component.exports